import type {
  APInvoiceAgentTab,
  APInvoiceHistoryKpis,
  APInvoiceHistoryRecord,
  APInvoiceUploadRequest,
} from "./types";

export function formatCurrency(value: number | null | undefined): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value ?? 0);
}

export function formatPercent(value: number | null | undefined): string {
  return `${Math.round((value ?? 0) * 100)}%`;
}

export function buildInvoiceHistoryKpis(
  rows: APInvoiceHistoryRecord[],
): APInvoiceHistoryKpis {
  const totalAmount = rows.reduce((sum, row) => sum + (row.amount ?? 0), 0);
  const readyForErpCount = rows.filter(
    (row) => row.export_status === "ready_for_erp",
  ).length;
  const needsReviewCount = rows.filter(
    (row) =>
      row.export_status !== "ready_for_erp" ||
      row.coding_status === "needs_review",
  ).length;
  const confidenceValues = rows
    .map((row) => row.extraction_confidence)
    .filter((value): value is number => typeof value === "number");
  const averageConfidence = confidenceValues.length
    ? confidenceValues.reduce((sum, value) => sum + value, 0) /
      confidenceValues.length
    : 0;

  return {
    invoiceCount: rows.length,
    totalAmount: Math.round(totalAmount * 100) / 100,
    readyForErpCount,
    needsReviewCount,
    averageConfidence: Math.round(averageConfidence * 100) / 100,
  };
}

export function buildInvoiceUploadForm({
  file,
  sourceMailbox,
  targetSystem,
}: APInvoiceUploadRequest): FormData {
  const form = new FormData();
  form.append("file", file);
  if (sourceMailbox) {
    form.append("source_mailbox", sourceMailbox);
  }
  if (targetSystem) {
    form.append("target_system", targetSystem);
  }
  return form;
}

export function routeToTab(pathname: string): APInvoiceAgentTab {
  if (pathname.includes("/configuration")) {
    return "configuration";
  }
  return "history";
}

export function tabToPath(tab: APInvoiceAgentTab): string {
  return tab === "configuration"
    ? "/ap-invoice-agent/configuration"
    : "/ap-invoice-agent";
}
